import { FinalFormatterMiddleware, TolgeePlugin } from '@tolgee/react';

function createFormatNoBrain(): FinalFormatterMiddleware {
    return {
        format: ({ translation, params }) => {
            if (params && Object.keys(params).length > 0) {
                return Object.entries(params)
                    .reduce(
                        (acc, [key, val]) => acc.replace(new RegExp(`#${key}#`), val),
                        translation,
                    );
            }
            return translation;
        },
    };
}

export const FormatNoBrain = (): TolgeePlugin => (tolgee, tools) => {
    tools.setFinalFormatter(createFormatNoBrain());
    return tolgee;
};
